/** 图标数据 License By  */
export default [
  {
    title: '线框',
    icons: [
      'el-icon-circle-plus-outline',
      'el-icon-remove-outline',
      'el-icon-circle-check',
      'el-icon-circle-close',
      'el-icon-_question',
      'el-icon-_info',
      'el-icon-warning-outline',
      'el-icon-_warning',
      'el-icon-_like',
      'el-icon-_dis',
      'el-icon-star-off',
      'el-icon-_heart',
      'el-icon-delete',
      'el-icon-user',
      'el-icon-coordinate',
      'el-icon-setting',
      'el-icon-_setting',
      'el-icon-more-outline',
      'el-icon-house',
      'el-icon-bell',
      'el-icon-chat-dot-square',
      'el-icon-_language',
      'el-icon-_network',
      'el-icon-_bug',
      'el-icon-monitor',
      'el-icon-data-line',
      'el-icon-brush',
      'el-icon-_integral',
      'el-icon-_menu',
      'el-icon-location-outline',
      'el-icon-collection',
      'el-icon-document',
      'el-icon-document-checked',
      'el-icon-document-delete',
      'el-icon-folder',
      'el-icon-folder-opened',
      'el-icon-picture-outline',
      'el-icon-camera',
      'el-icon-video-camera',
      'el-icon-phone-outline',
      'el-icon-suitcase',
      'el-icon-first-aid-kit',
      'el-icon-_backspace',
      'el-icon-wind-power',
      'el-icon-_wallet',
      'el-icon-_fly',
      'el-icon-_fire',
      'el-icon-_flash',
      'el-icon-help',
      'el-icon-_lamp',
      'el-icon-_school',
      'el-icon-goods',
      'el-icon-_shop',
      'el-icon-_table',
      'el-icon-_battery',
      'el-icon-receiving',
      'el-icon-_upload',
      'el-icon-sort',
      'el-icon-sort-up',
      'el-icon-sort-down',
      'el-icon-arrow-left',
      'el-icon-arrow-right',
      'el-icon-arrow-down',
      'el-icon-arrow-up',
      'el-icon-top-left',
      'el-icon-top-right',
      'el-icon-back',
      'el-icon-right',
      'el-icon-bottom',
      'el-icon-top',
      'el-icon-bottom-left',
      'el-icon-bottom-right',
      'el-icon-d-arrow-left',
      'el-icon-d-arrow-right',
      'el-icon-zoom-in',
      'el-icon-zoom-out',
      'el-icon-plus',
      'el-icon-minus',
      'el-icon-upload2',
      'el-icon-download',
      'el-icon-_download',
      'el-icon-finished',
      'el-icon-check',
      'el-icon-close',

      'el-icon-s-operation',
      'el-icon-set-up',
      'el-icon-switch-button',
      'el-icon-search',
      'el-icon-view',
      'el-icon-_eye-close',
      'el-icon-_more',
      'el-icon-_nav',
      'el-icon-s-fold',
      'el-icon-s-unfold',
      'el-icon-_fold',
      'el-icon-_unfold',
      'el-icon-refresh',
      'el-icon-refresh-right',
      'el-icon-refresh-left',
      'el-icon-loading',
      'el-icon-_loading',
      'el-icon-pie-chart',
      'el-icon-data-board',
      'el-icon-data-analysis',
      'el-icon-mobile-phone',
      'el-icon-mobile',
      'el-icon-_pad',
      'el-icon-mouse',
      'el-icon-_zoom-in',
      'el-icon-_zoom-out',
      'el-icon-_screen-full',
      'el-icon-_screen-restore',
      'el-icon-full-screen',
      'el-icon-_compress',
      'el-icon-copy-document',
      'el-icon-rank',
      'el-icon-crop',
      'el-icon-_user-group',
      'el-icon-_user-add',
      'el-icon-postcard',

      'el-icon-_terminal',
      'el-icon-_code',
      'el-icon-_var',
      'el-icon-_scan',
      'el-icon-_logout',
      'el-icon-_back-top',
      'el-icon-_back',
      'el-icon-_forward',
      'el-icon-_pushpin',
      'el-icon-_palette',
      'el-icon-_face-cry',
      'el-icon-_face-smile',
      'el-icon-lock',
      'el-icon-unlock',
      'el-icon-key',
      'el-icon-male',
      'el-icon-female',
      'el-icon-_transgender',

      'el-icon-time',
      'el-icon-alarm-clock',
      'el-icon-timer',
      'el-icon-odometer',
      'el-icon-stopwatch',
      'el-icon-discover',
      'el-icon-_template',
      'el-icon-_transfer',
      'el-icon-_component',
      'el-icon-_vercode',
      'el-icon-_prerogative',
      'el-icon-close-notification',
      'el-icon-chat-round',
      'el-icon-chat-line-round',
      'el-icon-chat-dot-round',
      'el-icon-chat-square',
      'el-icon-chat-line-square',
      'el-icon-message',

      'el-icon-edit',
      'el-icon-edit-outline',
      'el-icon-_feedback',
      'el-icon-_retrieve',
      'el-icon-_visa',
      'el-icon-tickets',
      'el-icon-notebook-1',
      'el-icon-notebook-2',
      'el-icon-reading',
      'el-icon-files',
      'el-icon-_save',
      'el-icon-document-copy',
      'el-icon-document-remove',
      'el-icon-document-add',
      'el-icon-folder-add',
      'el-icon-folder-remove',
      'el-icon-folder-delete',
      'el-icon-folder-checked',
      'el-icon-collection-tag',
      'el-icon-price-tag',
      'el-icon-discount',
      'el-icon-paperclip',
      'el-icon-link',
      'el-icon-connection',
      'el-icon-printer',
      'el-icon-takeaway-box',
      'el-icon-scissors',
      'el-icon-attract',
      'el-icon-c-scale-to-original',
      'el-icon-_straw',
      'el-icon-_surveying',
      'el-icon-_font-family',
      'el-icon-_font-size',
      'el-icon-date',
      'el-icon-_date-end',
      'el-icon-_date-start',

      'el-icon-_horn',
      'el-icon-_horn-close',
      'el-icon-_camera',
      'el-icon-headset',
      'el-icon-video-play',
      'el-icon-video-pause',
      'el-icon-_music',
      'el-icon-_video',
      'el-icon-film',
      'el-icon-mic',
      'el-icon-microphone',
      'el-icon-turn-off-microphone',

      'el-icon-_aite',
      'el-icon-_number',
      'el-icon-_percentage',
      'el-icon-_help',
      'el-icon-_usd',
      'el-icon-_rmb',
      'el-icon-_salary',
      'el-icon-_refund',
      'el-icon-_red-packet',
      'el-icon-shopping-cart-1',
      'el-icon-shopping-cart-2',
      'el-icon-shopping-cart-full',
      'el-icon-shopping-bag-1',
      'el-icon-shopping-bag-2',
      'el-icon-sold-out',
      'el-icon-sell',
      'el-icon-wallet',
      'el-icon-money',
      'el-icon-bank-card',
      'el-icon-_evaluate',
      'el-icon-_trending-up',
      'el-icon-_trending-down',
      'el-icon-_appointment',
      'el-icon-_appointment-ok',

      'el-icon-position',
      'el-icon-aim',
      'el-icon-map-location',
      'el-icon-location-information',
      'el-icon-add-location',
      'el-icon-delete-location',
      'el-icon-place',
      'el-icon-_programme',
      'el-icon-_infinite',
      'el-icon-service',
      'el-icon-suitcase-1',
      'el-icon-_brush',
      'el-icon-present',
      'el-icon-_target',
      'el-icon-_api',
      'el-icon-_timeline',
      'el-icon-_condition',
      'el-icon-_connecting-line',
      'el-icon-_temperature',
      'el-icon-picture-outline-round',
      'el-icon-_cols',
      'el-icon-_share',
      'el-icon-_keyboard',
      'el-icon-_filter',
      'el-icon-_database',
      'el-icon-coin',
      'el-icon-_mate',
      'el-icon-news',
      'el-icon-open',
      'el-icon-turn-off',
      'el-icon-_footprint',
      'el-icon-box',
      'el-icon-_hammer',
      'el-icon-magic-stick',
      'el-icon-_compute',
      'el-icon-_function',
      'el-icon-bangzhu',
      'el-icon-office-building',
      'el-icon-school',
      'el-icon-_snow',
    ],
  },
  {
    title: '实心',
    icons: [
      'el-icon-circle-plus',
      'el-icon-remove',
      'el-icon-success',
      'el-icon-error',
      'el-icon-question',
      'el-icon-info',
      'el-icon-warning',
      'el-icon-_warning-solid',
      'el-icon-_like-solid',
      'el-icon-_dis-solid',
      'el-icon-star-on',
      'el-icon-_heart-solid',
      'el-icon-delete-solid',
      'el-icon-user-solid',
      'el-icon-s-check',
      'el-icon-s-tools',
      'el-icon-_setting-solid',
      'el-icon-more',
      'el-icon-s-home',
      'el-icon-message-solid',
      'el-icon-s-comment',
      'el-icon-_language-solid',
      'el-icon-_globe',
      'el-icon-_bug-solid',
      'el-icon-s-platform',
      'el-icon-s-marketing',
      'el-icon-s-open',
      'el-icon-_integral-solid',
      'el-icon-menu',
      'el-icon-location',
      'el-icon-s-management',
      'el-icon-s-order',
      'el-icon-s-claim',
      'el-icon-s-release',
      'el-icon-_folder',
      'el-icon-_folder-open',
      'el-icon-picture',
      'el-icon-camera-solid',
      'el-icon-video-camera-solid',
      'el-icon-phone',
      'el-icon-s-cooperation',
      'el-icon-_medkit-solid',
      'el-icon-_backspace-solid',
      'el-icon-s-flag',
      'el-icon-s-finance',
      'el-icon-_airplane',
      'el-icon-_fire-solid',
      'el-icon-_flash-solid',
      'el-icon-s-help',
      'el-icon-s-opportunity',
      'el-icon-_school-solid',
      'el-icon-s-goods',
      'el-icon-s-shop',
      'el-icon-s-grid',
      'el-icon-_battery-full',
      'el-icon-_retrieve-solid',
      'el-icon-upload',
      'el-icon-d-caret',
      'el-icon-caret-top',
      'el-icon-caret-bottom',
      'el-icon-caret-left',
      'el-icon-caret-right',
      'el-icon-s-promotion',
      'el-icon-s-ticket',
      'el-icon-share',
      'el-icon-s-custom',
      'el-icon-_lock-solid',
      'el-icon-_unlock-solid',
      'el-icon-_vercode-solid',
      'el-icon-_email-solid',
      'el-icon-_refund-solid',
      'el-icon-_money-solid',
      'el-icon-_brush-solid',
      'el-icon-_palette-solid',
      'el-icon-_tag-sloid',
      'el-icon-_puzzle-solid',
      'el-icon-_prerogative-solid',
      'el-icon-_prerogative2-solid',
      'el-icon-_service-solid',
      'el-icon-_evaluate-solid',
      'el-icon-_prerogative3-solid',
      'el-icon-_present-sloid',
      'el-icon-_red-packet-solid',
      'el-icon-_ticket-sloid',
      'el-icon-_user-group-solid',
      'el-icon-_camera2-solid',
      'el-icon-_shopping-cart-sloid',
      'el-icon-_time-solid',
      'el-icon-_news-solid',
      'el-icon-_database-solid',
      'el-icon-_postcard-solid',
      'el-icon-_bus-sloid',
      'el-icon-_car-sloid',
      'el-icon-_truck-sloid',
      'el-icon-_analysis-solid',
      'el-icon-_pie-chart-solid',
      'el-icon-_compute-solid',
      'el-icon-_live-solid',
      'el-icon-_printer-solid',
      'el-icon-_bank-card-solid',
      'el-icon-_target-sloid',
      'el-icon-_horn-sloid',
      'el-icon-_service',
      'el-icon-_cube',
      'el-icon-_sent',
      'el-icon-_love',
      'el-icon-_quote1',
      'el-icon-_quote2',
      'el-icon-s-data',
      'el-icon-_game-solid',
      'el-icon-_fingerprint',
      'el-icon-_barcode',
      'el-icon-_qrcode',
      'el-icon-_tree',
      'el-icon-_leaf',
      'el-icon-_flask',
      'el-icon-_nuclear',
      'el-icon-_recycle',
      'el-icon-_rocket',
      'el-icon-platform-eleme',
      'el-icon-eleme',
      'el-icon-_github',
      'el-icon-_gitee',
      'el-icon-_qq',
      'el-icon-_wechat',
      'el-icon-_wxpay',
      'el-icon-_alipay',
      'el-icon-_taobao',
      'el-icon-_weibo',
      'el-icon-_qqzone',
      'el-icon-_wxzone',
      'el-icon-_twitter',
      'el-icon-_trophy-solid',
      'el-icon-_zhihu',
      'el-icon-_ie',
      'el-icon-_chrome',
      'el-icon-_windows',
      'el-icon-_ios',
      'el-icon-_android',
      'el-icon-_bluetooth-solid',
      'el-icon-_bluetooth',
      'el-icon-_wifi',
      'el-icon-_rss',
      'el-icon-_signal-box',
      'el-icon-_signal',
      'el-icon-_usb',
      'el-icon-_command-ios',
      'el-icon-_walk',
      'el-icon-_man',
      'el-icon-_woman',
      'el-icon-_recommend',
    ],
  },
  {
    title: '其他',
    icons: [
      'el-icon-_state1',
      'el-icon-_state2',
      'el-icon-_state3',
      'el-icon-_state4',
      'el-icon-_state5',
      'el-icon-_state6',
      'el-icon-_state7',
      'el-icon-_state8',
      'el-icon-_state9',
      'el-icon-_state10',
      'el-icon-_state11',
      'el-icon-_state12',
      'el-icon-thumb',
      'el-icon-guide',
      'el-icon-cpu',
      'el-icon-umbrella',
      'el-icon-smoking',
      'el-icon-no-smoking',
      'el-icon-bicycle',
      'el-icon-_car',
      'el-icon-_bus',
      'el-icon-truck',
      'el-icon-watch',
      'el-icon-watch-1',
      'el-icon-medal',
      'el-icon-medal-1',
      'el-icon-trophy',
      'el-icon-trophy-1',
      'el-icon-toilet-paper',
      'el-icon-table-lamp',
      'el-icon-ship',
      'el-icon-refrigerator',
      'el-icon-basketball',
      'el-icon-football',
      'el-icon-soccer',
      'el-icon-baseball',
      'el-icon-moon',
      'el-icon-moon-night',
      'el-icon-sunrise',
      'el-icon-sunrise-1',
      'el-icon-sunny',
      'el-icon-sunset',
      'el-icon-partly-cloudy',
      'el-icon-cloudy',
      'el-icon-cloudy-and-sunny',
      'el-icon-heavy-rain',
      'el-icon-light-rain',
      'el-icon-lightning',
      'el-icon-dish',
      'el-icon-dish-1',
      'el-icon-food',
      'el-icon-chicken',
      'el-icon-fork-spoon',
      'el-icon-knife-fork',
      'el-icon-burger',
      'el-icon-tableware',
      'el-icon-sugar',
      'el-icon-dessert',
      'el-icon-ice-cream',
      'el-icon-hot-water',
      'el-icon-water-cup',
      'el-icon-coffee-cup',
      'el-icon-cold-drink',
      'el-icon-goblet',
      'el-icon-goblet-full',
      'el-icon-goblet-square',
      'el-icon-goblet-square-full',
      'el-icon-grape',
      'el-icon-watermelon',
      'el-icon-cherry',
      'el-icon-apple',
      'el-icon-pear',
      'el-icon-orange',
      'el-icon-coffee',
      'el-icon-ice-tea',
      'el-icon-ice-drink',
      'el-icon-milk-tea',
      'el-icon-potato-strips',
      'el-icon-lollipop',
      'el-icon-ice-cream-square',
      'el-icon-ice-cream-round',
    ],
  },
];
